import moment from 'moment';
import { Draggable } from "@fullcalendar/interaction";

const calendarMixin = {
    methods: {
        
        setUpDraggable() {
            new Draggable( document.getElementById( "draggable-area" ), {
                itemSelector: ".fc-event",
            } );
        },
        
        checkForTiming( eventItem, eventsArray ) {
            
            let start = eventItem.start;
            let end = eventItem.end;
            
            let startTime = moment( eventItem.start ).format( 'YYYY-MM-DD HH:mm' );
            let endTime = moment( eventItem.end ).format( 'YYYY-MM-DD HH:mm' );
            
            let eventInfo = eventItem.extendedProps;
            
            //get events on that day
            let arr = this.getDayEvents( start, eventsArray, parseInt( eventItem.id ) );
            
            
            for ( let i = 0; i < arr.length; i++ ) {
                
                
                let item = arr[i];
                let itemEnd = moment( item.end ).toDate();
                let itemStart = moment( item.start ).toDate();
                
                
                if ( moment( itemStart ).isSame( start ) && item.availableCount >= eventInfo.candidateCount ) {
                    return {
                        startTime: startTime,
                        endTime: endTime
                    };
                }
                
                
                if ( moment( end ).isBefore( itemStart ) && i === 0 )
                    return {
                        startTime: startTime,
                        endTime: endTime
                    };
                else if ( arr.length === 1 && moment( itemEnd ).isBefore( start ) )
                    return {
                        startTime: startTime,
                        endTime: endTime
                    };
                else if ( ( i + 1 ) >= arr.length )
                    return this.getAppropriateTiming( itemEnd, eventItem );
                
                
                let nextItem = null;
                let nextStart = null;
                let nextEnd = null;
                
                if ( ( i + 1 ) < arr.length ) {
                    nextItem = arr[i + 1];
                    nextStart = moment( nextItem.start ).toDate();
                    nextEnd = moment( nextItem.end ).toDate();
                }
                
                
                if ( nextItem ) {
                    if ( moment( nextStart ).isAfter( end ) && moment( start ).isAfter( itemEnd ) ) {
                        return {
                            startTime: startTime,
                            endTime: endTime,
                        };
                    }
                }
                
            }
            
            return null;
            
        },
        
        getAppropriateTiming( maxDateTime, eventItem ) {
            
            let startTime = moment( maxDateTime ).add( this.testingInterval, 'minutes' ).format( 'YYYY-MM-DD HH:mm' );
            
            let diffMinutes = ( moment( eventItem.end ).minutes() ) - ( moment( eventItem.start ).minutes() );
            let diffHours = ( moment( eventItem.end ).hours() ) - ( moment( eventItem.start ).hours() );
            
            let hours = diffHours + ( diffMinutes / 60 );
            
            let endTime = moment( startTime, 'YYYY-MM-DD HH:mm' ).add( hours, 'hours' ).format( 'YYYY-MM-DD HH:mm' );
            
            return {
                startTime: startTime,
                endTime: endTime,
            };
        },
        
        getDateParams() {
            let dateFrom = null;
            let dateTo = null;
            
            if ( this.calendarApi ) {
                dateFrom = moment( this.calendarApi.view.activeStart ).format( 'YYYY-MM-DD' );
                dateTo = moment( this.calendarApi.view.activeEnd ).format( 'YYYY-MM-DD' );
            }
            else {
                let m = moment().format( 'MM' );
                let y = moment().format( 'YYYY' );
                let days = moment().daysInMonth( ( parseInt( m ) ) - 1 );
                
                dateFrom = moment( y + '-' + m + '-' + '01' ).format( 'YYYY-MM-DD' );
                dateTo = moment( y + '-' + m + '-' + days ).format( 'YYYY-MM-DD' );
            }
            
            return { dateTo: dateTo, dateFrom: dateFrom };
        },
        
        //get events in one day (datetime)
        getDayEvents( datetime, eventsArray, notId = null ) {
            
            datetime = moment( datetime ).format( 'YYYY-MM-DD' );
            
            //convert datetime to comparable date
            datetime = moment( datetime, 'YYYY-MM-DD' ).toDate();
            
            let arr = [];
            
            for ( let i = 0; i < eventsArray.length; i++ ) {
                
                if ( notId && eventsArray[i].id === notId )
                    continue;
                
                // convert datetime to date
                let eventTime = moment( eventsArray[i].startTime, 'YYYY-MM-DD HH:mm' ).format( 'YYYY-MM-DD' );
                
                //convert to comparable date
                eventTime = moment( eventTime, 'YYYY-MM-DD' ).toDate();
                
                
                if ( moment( datetime ).isSame( eventTime ) )
                    arr.push( eventsArray[i] );
                
            }
            
            return arr;
            
        },
        
        getLastEventTime( datetime, eventsArray = [], notId = null, max = true, item = null ) {
            
            datetime = moment( datetime ).format( 'YYYY-MM-DD' );
            
            //conversion to compare dates
            datetime = moment( datetime, 'YYYY-MM-DD' ).toDate();
            
            let arr = this.getDayEvents( datetime, eventsArray, notId );
            
            let startMax = null;
            let endMax = null;
            
            if ( arr.length > 0 ) {
                
                startMax = moment( arr[0].startTime, 'YYYY-MM-DD HH:mm' ).toDate();
                endMax = moment( arr[0].endTime, 'YYYY-MM-DD HH:mm' ).toDate();
                
                for ( let i = 0; i < arr.length; i++ ) {
                    
                    let itemEvent = arr[i];
                    
                    let startTime = moment( itemEvent.startTime, 'YYYY-MM-DD HH:mm' ).toDate();
                    let endTime = moment( itemEvent.endTime, 'YYYY-MM-DD HH:mm' ).toDate();
                    
                    if ( itemEvent.availableCount > 0 ) {
                        return {
                            available: true,
                            time: startTime
                        }
                    }
                    
                    if ( moment( startTime ).isAfter( startMax ) )
                        startMax = endTime;
                    
                    if ( moment( endTime ).isAfter( endMax ) )
                        endMax = endTime;
                }
            }
            
            if ( max )
                return endMax;
            
            else if ( startMax && endMax )
                return {
                    start: startMax,
                    end: endMax
                };
            
            return null;
        },
        
        getMaxDate( eventsArray = [], notId = null ) {
            let max = null;
            
            max = moment( eventsArray[0].endTime, 'YYYY-MM-DD HH:mm' ).toDate();
            
            for ( let i = 0; i < eventsArray.length; i++ ) {
                
                if ( notId && eventsArray[i].id === notId )
                    continue;
                
                let end = moment( eventsArray[i].endTime, 'YYYY-MM-DD HH:mm' ).toDate();
                
                if ( moment( end ).isAfter( max ) )
                    max = end;
                
            }
            
            return max;
        },
    }
};
export default calendarMixin;
